exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-deliverable-modal.edit-project-modal .field-header{border:unset;background:linear-gradient(180deg,var(--wf-secondary) 0,var(--edit-deliverable-modal-edit-project-modal-field-header-lgbg) 86%,var(--db-collapse-control-lgbg))}.edit-deliverable-modal.edit-project-modal .field-box .field-wrap{border:unset}", ""]);

// exports
